<script>
export default {
    name: "CancelExpense",

    props: {

        showModal: Boolean,
        expense: Object,
    },

    methods: {

        saveData() {

            this.$root.loading=true;
            this.$http.post(`Accounting/ExpenseCancellation`, 
            this.expense)
                    .then(() => {
                        this.$emit(`refresh`);
                        this.$root.loading=false;
                        this.$emit(`closeModal`);
                }).catch(() => { this.$root.loading=false; });
        },
    }
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/4 w-11/12">
      <template v-slot:title>
        <h5 class="font-medium text-base">Cancel Expense</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full text-center">
            <h5 class="text-base text-red-600">
                Confirm  Cancel Expense No: {{ expense.expenseNo }} </h5>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button 
            class="btn-danger btn-sm text-xs rounded mr-6" 
            @click.prevent="$emit(`closeModal`)">
                <i class="fa fa-times"></i> Close</button>
        <button 
            @click.prevent="saveData"
            class="btn-primary btn-sm text-xs rounded">
                <i class="fa fa-check"></i> Delete</button>
      </template>
    </tail-modal>
</template>